export class ContextDTO {
  is_complete = false;
  is_input_card = false;
  nick_name = '';
  is_join_line_at = false;
  not_reading_count = 0;

  is_billing_term = false;
}
